import { render, staticRenderFns } from "./buscarDocexterno.vue?vue&type=template&id=ba1592aa&scoped=true"
import script from "./buscarDocexterno.vue?vue&type=script&lang=js"
export * from "./buscarDocexterno.vue?vue&type=script&lang=js"
import style0 from "./buscarDocexterno.vue?vue&type=style&index=0&id=ba1592aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1592aa",
  null
  
)

export default component.exports